import { obtenerUsuario, obtenerToken, obtenerSesion } from "./authService";

// Registro en memoria de errores recientes para evitar saturación/spam en caso de bucles
const erroresRecientes = new Set();

/**
 * Registra un error de ejecución de JavaScript o de render de React en la Bitácora de Errores.
 */
export const registrarErrorFrontend = (error, origen = "JS_RUNTIME") => {
    try {
        if (!error) return;

        const mensaje = (typeof error === "string" ? error : error?.message || "").trim();
        if (!mensaje) return;

        // Evitar bucles infinitos si la llamada a BitacoraError fallara
        if (mensaje.includes("BitacoraError")) return;

        const stack = error?.stack || "";
        const clave = `${mensaje}::${stack.slice(0, 100)}`;
        if (erroresRecientes.has(clave)) return;
        erroresRecientes.add(clave);
        setTimeout(() => erroresRecientes.delete(clave), 5000);

        const token = obtenerToken();
        const sesion = obtenerSesion();

        const rutaLimpia = window.location.pathname.replace(/^\//, "");
        const partesRuta = rutaLimpia.split("/");
        const modulo = (partesRuta[0] || "FRONTEND").substring(0, 60);
        const operacion = (partesRuta[1] || "RENDER").substring(0, 100);

        const codigoError = (typeof error === "object" && error?.name ? error.name : origen).substring(0, 60);

        fetch((process.env.REACT_APP_API_URL || "") + "/BitacoraError/Add", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
                ...(sesion ? { "X-Session-Id": sesion } : {}),
            },
            body: JSON.stringify({
                nivel: "ERROR",
                categoria: "FRONTEND",
                codigoError: codigoError,
                mensaje: mensaje.substring(0, 400),
                modulo: modulo,
                operacion: operacion,
                usuario: (obtenerUsuario() || "").substring(0, 60) || null,
                sesionId: sesion && !isNaN(parseInt(sesion, 10)) ? parseInt(sesion, 10) : null,
                endpoint: `${window.location.pathname}${window.location.search}`.substring(0, 100),
                detalleTecnico: stack
                    ? stack.slice(0, 2000)
                    : (typeof error === "object" ? JSON.stringify(error).slice(0, 2000) : null),
            }),
        }).catch(() => {});
    } catch {
        // Ignorar fallas internas para no alterar la ejecución del usuario
    }
};

/**
 * Escucha eventos globales de JavaScript en la ventana del navegador.
 */
export const inicializarCapturaErroresFrontend = () => {
    if (typeof window === "undefined") return;

    window.addEventListener("error", (event) => {
        // Ignorar errores sin información o de extensiones sin stack
        if (!event.error && !event.message) return;
        registrarErrorFrontend(event.error || event.message, "WINDOW_ERROR");
    });

    window.addEventListener("unhandledrejection", (event) => {
        const reason = event.reason;
        if (!reason || reason?.__CANCEL__) return;
        registrarErrorFrontend(reason, "UNHANDLED_PROMISE");
    });
};

